
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/coach/[slug]",
      function () {
        return require("private-next-pages/coach/[slug]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/coach/[slug]"])
      });
    }
  